import { useState, useEffect } from 'react';

export const useGetMaterias = () => {

    const [state, setState] = useState({
        data: [],
        loading: true
    });

    useEffect(() => {
        const fetchData = () => {
            fetch(window.location.origin + '/Calificaciones/getMaterias')
                .then(async function(response) {
                    console.log(response);
                    if(response.status != 200){
                        setState({
                            data: response.status,
                            loading: false
                        })
                    }else{
                        const data = await response.json();
                        setState({
                            data: data,
                            loading: false
                        })
                    }
                })
        }
        fetchData();
    }, []);

    return state;
}
